import { isHydricStress } from './MetricIds';
export var Brand;
(function (Brand) {
    Brand[Brand["weenat"] = 0] = "weenat";
    Brand[Brand["pessl"] = 1] = "pessl";
    Brand[Brand["davis"] = 2] = "davis";
    Brand[Brand["adcon"] = 3] = "adcon";
    Brand[Brand["corhize"] = 4] = "corhize";
})(Brand || (Brand = {}));
export var DeviceCategory;
(function (DeviceCategory) {
    DeviceCategory[DeviceCategory["irrigationProbes"] = 0] = "irrigationProbes";
    DeviceCategory[DeviceCategory["agroWeather"] = 1] = "agroWeather";
})(DeviceCategory || (DeviceCategory = {}));
export var DeviceBroadcastNetwork;
(function (DeviceBroadcastNetwork) {
    DeviceBroadcastNetwork[DeviceBroadcastNetwork["SIGFOX"] = 0] = "SIGFOX";
    DeviceBroadcastNetwork[DeviceBroadcastNetwork["LoRa"] = 1] = "LoRa";
    DeviceBroadcastNetwork[DeviceBroadcastNetwork["CELLULAR"] = 2] = "CELLULAR";
})(DeviceBroadcastNetwork || (DeviceBroadcastNetwork = {}));
const ALL_WEENAT_MODELS = [
    'CAPA 60-6',
    'CAPA-30-3',
    'CAPA-60-6',
    'CAPA-3010',
    'CAPA-6010',
    'CAPA',
    'CHP 15/30',
    'CHP 60/90',
    'CHP-10',
    'CHP-15/30',
    'CHP-20',
    'CHP-30/60',
    'CHP-60/90',
    'CHP-90',
    'CHP',
    'LWS',
    'LWS+',
    'Mini-T',
    'P',
    'P+ IN simple',
    'P+',
    'PAR',
    'PT',
    'PYR',
    'PYRANO',
    'T_GEL',
    'T_MINI',
    'T',
    'T5CHP30',
    'T5CHP30+',
    'T5CHP60',
    'T5CHP60+',
    'T5HP30',
    'T5HP60',
    'T10',
    'T15',
    'TCHP',
    'TCHP+',
    'TCHP20',
    'TH',
    'THP35',
    'TSA',
    'VM',
    'VM+',
    'VU+',
    'W',
    'W+',
    'Détruit',
    'CIMPOD15 5.00A',
    'PCB 2.504',
    'HP',
    'HP60',
    'Pessl',
    'Davis',
    'EC'
];
const EXTERNAL_MODELS = [
    '10HS',
    '2nd Temp',
    'Anemometer',
    'Barometer',
    'GroWeather',
    'Leaf Wetness 1',
    'Leaf Wetness 2',
    'Leaf Wetness Sensor',
    'LoRAIN (NBIoT)',
    'Pyranomètre',
    'Rain Collector',
    'Soil Moisture 1',
    'Soil Moisture 2',
    'Soil Moisture 3',
    'Soil Moisture 4',
    'Soil Temp 1',
    'Soil Temp 2',
    'Soil Temp 3',
    'Soil Temp 4',
    'Solar Radiation',
    'Station météo',
    'Temperature Probe',
    'Ultra Violet',
    'Vantage Pro2',
    'Vantage Pro2 Plus',
    'iMetos 1',
    'iMetos 2',
    'iMetos 3.3',
    'iMetos ECO D3',
    'uMETOS CLIMA',
    'uMETOS SOIL'
];
export var Origin;
(function (Origin) {
    /**
     * The device is owned by this organization I am accessing it with
     */
    Origin["fromOwnOrganization"] = "own";
    /**
     * I can access the device because it's directly owned by the network I'm subscribed to
     * This means that the organization accessing this device is an adherent farm
     * The id of the network is networkId inside the current organization
     */
    Origin["fromNetwork"] = "nw";
    /**
     * I can access the device because it's owned by a fellow adherent farm
     * This means that the organization accessing this device is an adherent farm
     */
    Origin["fromAdherentFarm"] = "nw_org";
    /**
     * I can access the device because it's owned by one of my adherent farm
     * This means that the organization accessing this device is a network
     */
    Origin["fromASubscribingAdherentFarm"] = "subscriber";
})(Origin || (Origin = {}));
/**
 * Enums of the different thresholds in minutes after which we issue a warning.
 * Depending on the brand, type or use of the device
 */
export var UpdateWarningThresholds;
(function (UpdateWarningThresholds) {
    UpdateWarningThresholds[UpdateWarningThresholds["default"] = 25] = "default";
    UpdateWarningThresholds[UpdateWarningThresholds["virtualDevices"] = 65] = "virtualDevices";
    UpdateWarningThresholds[UpdateWarningThresholds["pessl"] = 120] = "pessl";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    UpdateWarningThresholds[UpdateWarningThresholds["davis"] = 120] = "davis";
    UpdateWarningThresholds[UpdateWarningThresholds["irrigation"] = 180] = "irrigation";
    /** 24h in minutes */
    UpdateWarningThresholds[UpdateWarningThresholds["hydricdeficit"] = 1440] = "hydricdeficit";
})(UpdateWarningThresholds || (UpdateWarningThresholds = {}));
export const getWarningThresholdsFromBrand = (brand, metric) => {
    let warningThreshold;
    if (brand != undefined) {
        if (brand === Brand.pessl) {
            warningThreshold = UpdateWarningThresholds.pessl;
        }
        else if (brand === Brand.davis) {
            warningThreshold = UpdateWarningThresholds.davis;
        }
    }
    if (metric != undefined && isHydricStress(metric)) {
        warningThreshold = UpdateWarningThresholds.irrigation;
    }
    if (metric != undefined && metric === 'HDEF') {
        warningThreshold = UpdateWarningThresholds.hydricdeficit;
    }
    return warningThreshold;
};
